{
  "version": "1.2.6",
  "objects": {
    "7536295120993543774": {
      "type": "frame",
      "id": "7536295120993543774",
      "z": 11757,
      "textContent": "",
      "left": 6723.588145850886,
      "top": 1275.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.49469889016763774,
      "scaleY": 0.9013541232363048,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7536295120996226046": {
      "type": "frame",
      "id": "7536295120996226046",
      "z": -1005,
      "textContent": "",
      "left": 6753.588145850886,
      "top": 1746.6841534045886,
      "width": 1110,
      "height": 625,
      "scaleX": 0.4406448361135837,
      "scaleY": 0.1,
      "fill": "#FFFFFF",
      "opacity": 0.1,
      "container": "7536295120993543774",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a22t1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295120991748594": {
      "type": "wireframe",
      "id": "7536295120991748594",
      "z": 11277,
      "top": 1766.6841534045886,
      "left": 6902.047030870487,
      "width": 254.9306640625,
      "height": 30,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7536295120996226046",
      "wireframeName": "pagination",
      "fill": "#804ACB",
      "itemsData": {
        "7536244467334959304": {
          "id": "7536244467334959304",
          "state": "default",
          "value": 3,
          "item_position": 2000000
        },
        "7536244467344158119": {
          "id": "7536244467344158119",
          "state": "default",
          "value": 1,
          "item_position": 0
        },
        "7536244467350206481": {
          "id": "7536244467350206481",
          "state": "selected",
          "value": 2,
          "item_position": 1000000
        },
        "7536245665039097939": {
          "id": "7536245665039097939",
          "value": "4",
          "item_position": 3000000
        },
        "7536245665931476452": {
          "id": "7536245665931476452",
          "value": "5",
          "item_position": 4000000
        }
      },
      "textColor": "#333333",
      "style": "unframed",
      "fontSize": 14,
      "label": {},
      "placeholder": {},
      "showIcons": true,
      "showButtonText": false,
      "showEllipses": false,
      "buttonLeft": "Prev",
      "buttonRight": "Next"
    },
    "7536295120999263227": {
      "type": "frame",
      "id": "7536295120999263227",
      "z": -1005,
      "textContent": "",
      "left": 6753.588145850886,
      "top": 1305.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.4406448361135837,
      "scaleY": 0.1136,
      "fill": "#FFFFFF",
      "opacity": 0.1,
      "container": "7536295120993543774",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1eKAfZX",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120988416584": {
      "type": "wireframe",
      "id": "7536295120988416584",
      "z": 10690,
      "top": 1326.3378263818981,
      "left": 7074.759982200143,
      "width": 209.25857564909407,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7536295120999263227",
      "layoutPosition": "a19QK",
      "wireframeName": "searchBar",
      "fill": "#BDBDBD",
      "itemsData": {
        "7448682831889818158": {
          "id": "7448682831889818158",
          "value": "Item",
          "item_position": 0
        },
        "7448682831890807466": {
          "id": "7448682831890807466",
          "value": "Item",
          "item_position": 1000000
        },
        "7448682831897867802": {
          "id": "7448682831897867802",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Search gallery",
        "iconLeft": { "prefix": "fas", "iconName": "magnifying-glass" }
      },
      "setDimension": true
    },
    "7536295120994200441": {
      "type": "shape",
      "id": "7536295120994200441",
      "z": 11287,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#000000\">Title</span></p>",
      "left": 6763.588145850886,
      "top": 1315.8378263818981,
      "width": 36.16666666666667,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7536295120999263227",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": null,
      "maskType": "none",
      "locked": false
    },
    "7536295120993919453": {
      "type": "frame",
      "id": "7536295120993919453",
      "z": -985,
      "textContent": "",
      "left": 6753.588145850886,
      "top": 1386.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.4406448361135837,
      "scaleY": 0.5597541232363048,
      "fill": "transparent",
      "opacity": 0.1,
      "container": "7536295120993543774",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1eKB",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 0,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295120997077185": {
      "type": "frame",
      "id": "7536295120997077185",
      "z": 11,
      "textContent": "",
      "left": 6919.960068546245,
      "top": 1396.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.14087560603185523,
      "scaleY": 0.5277541232363048,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120993919453",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a10YM",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 5,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295120988187027": {
      "type": "frame",
      "id": "7536295120988187027",
      "z": 22,
      "textContent": "",
      "left": 6924.960068546245,
      "top": 1462.7968576065578,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.19910983663842471,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295120997077185",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a07YN",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120999757871": {
      "type": "shape",
      "id": "7536295120999757871",
      "z": 11327,
      "shapeName": "icon",
      "textContent": "",
      "left": 6984.638626326531,
      "top": 1512.0112779886724,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295120988187027",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a18Hb",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295120998331630": {
      "type": "frame",
      "id": "7536295120998331630",
      "z": 44,
      "textContent": "",
      "left": 6924.960068546245,
      "top": 1401.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.08153444995945537,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295120997077185",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zzs762gG",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120993851992": {
      "type": "shape",
      "id": "7536295120993851992",
      "z": 11317,
      "shapeName": "icon",
      "textContent": "",
      "left": 6984.638626326531,
      "top": 1414.3099384268348,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295120998331630",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1AjI",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295121004375703": {
      "type": "frame",
      "id": "7536295121004375703",
      "z": 55,
      "textContent": "",
      "left": 6924.960068546245,
      "top": 1597.2405055055733,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.19910983663842471,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295120997077185",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2BI7",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121003697624": {
      "type": "shape",
      "id": "7536295121003697624",
      "z": 11347,
      "shapeName": "icon",
      "textContent": "",
      "left": 6984.638626326531,
      "top": 1646.454925887688,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295121004375703",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1BOG",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295121000223075": {
      "type": "frame",
      "id": "7536295121000223075",
      "z": 11197,
      "textContent": "",
      "left": 6763.588145850886,
      "top": 1396.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.14087560603185523,
      "scaleY": 0.5277541232363048,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120993919453",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0C9o",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 5,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295120992212666": {
      "type": "frame",
      "id": "7536295120992212666",
      "z": 224,
      "textContent": "",
      "left": 6768.588145850886,
      "top": 1401.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.19524112558875914,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295121000223075",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zy5nI",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120995854373": {
      "type": "shape",
      "id": "7536295120995854373",
      "z": 11337,
      "shapeName": "icon",
      "textContent": "",
      "left": 6828.266703631172,
      "top": 1449.8432745609923,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295120992212666",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a29Vx",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295121004129370": {
      "type": "frame",
      "id": "7536295121004129370",
      "z": 225,
      "textContent": "",
      "left": 6768.588145850886,
      "top": 1533.8635298748727,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.08927187205878653,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295121000223075",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zzs762gG",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121000815044": {
      "type": "shape",
      "id": "7536295121000815044",
      "z": 11367,
      "shapeName": "icon",
      "textContent": "",
      "left": 6828.266703631172,
      "top": 1548.7535863258504,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295121004129370",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2ALa",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295120991323046": {
      "type": "frame",
      "id": "7536295120991323046",
      "z": 226,
      "textContent": "",
      "left": 6768.588145850886,
      "top": 1599.6584499116143,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.19524112558875914,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295121000223075",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2BI7",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120996828077": {
      "type": "shape",
      "id": "7536295120996828077",
      "z": 11357,
      "shapeName": "icon",
      "textContent": "",
      "left": 6828.266703631172,
      "top": 1647.6638980907085,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295120991323046",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a299C",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295120999377871": {
      "type": "frame",
      "id": "7536295120999377871",
      "z": 11207,
      "textContent": "",
      "left": 7076.331991241604,
      "top": 1396.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.14087560603185523,
      "scaleY": 0.5277541232363048,
      "fill": "transparent",
      "opacity": 1,
      "container": "7536295120993919453",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a29yO",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 5,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7536295120997319642": {
      "type": "frame",
      "id": "7536295120997319642",
      "z": 228,
      "textContent": "",
      "left": 7081.331991241604,
      "top": 1511.7866020561282,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.15991804107876825,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295120999377871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a07YN",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121001064146": {
      "type": "shape",
      "id": "7536295121001064146",
      "z": 11297,
      "shapeName": "icon",
      "textContent": "",
      "left": 7141.01054902189,
      "top": 1548.7535863258504,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295120997319642",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a20Ui",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295121003218337": {
      "type": "frame",
      "id": "7536295121003218337",
      "z": 229,
      "textContent": "",
      "left": 7081.331991241604,
      "top": 1401.8378263818981,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.15991804107876825,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295120999377871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zzs762gG",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121002392673": {
      "type": "shape",
      "id": "7536295121002392673",
      "z": 11217,
      "shapeName": "icon",
      "textContent": "",
      "left": 7141.01054902189,
      "top": 1438.8048106516203,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295121003218337",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a16lQ",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    },
    "7536295120990974016": {
      "type": "frame",
      "id": "7536295120990974016",
      "z": 230,
      "textContent": "",
      "left": 7081.331991241604,
      "top": 1621.7353777303583,
      "width": 1110,
      "height": 625,
      "scaleX": 0.13186659702284623,
      "scaleY": 0.15991804107876825,
      "fill": "#854AD7",
      "opacity": 0.05,
      "container": "7536295120999377871",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2BI7",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295121004396819": {
      "type": "shape",
      "id": "7536295121004396819",
      "z": 11307,
      "shapeName": "icon",
      "textContent": "",
      "left": 7141.01054902189,
      "top": 1658.7023620000805,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.26014807134786055,
      "scaleY": 0.26014807134786055,
      "stroke": "transparent",
      "strokeWidth": 1,
      "opacity": 0.2,
      "borderOpacity": 1,
      "fill": "#854AD7",
      "angle": 0,
      "container": "7536295120990974016",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a27rD",
      "maskType": "none",
      "iconName": "fas/image",
      "locked": false
    }
  }
}
